import { useCallback, useState } from "react";
import ChatBodyWrap from "./ChatbodyWrap";
import clsx from "clsx";
import styles from "./Bot.module.scss";
import ChevronDownIcon from "./ChevronDownIcon";
import ChatIcon from "./ChatIcon";
import FaqBody from "./FaqBody";

const Chatbot = () => {
  const [isOpenChat, setIsOpenChat] = useState<boolean>(false);

  const handleToggleChat = useCallback(() => {
    setIsOpenChat((pr) => !pr);
  }, []);

  const classNamesButton = clsx(styles.chatButton, {
    [styles.buttonOpen]: isOpenChat,
  });

  const classNamesButtonIconChevron = clsx(
    styles.chatButtonIcon,
    styles.chatButtonIconChevron,
    {
      [styles.chatButtonIconChevronOpen]: isOpenChat,
    }
  );

  const classNamesButtonIconChat = clsx(
    styles.chatButtonIcon,
    styles.classNamesButtonIconChat,
    {
      [styles.classNamesButtonIconChatOpen]: isOpenChat,
    }
  );

  return (
    <div className={styles.chatContainer}>
      <ChatBodyWrap isOpen={isOpenChat}>
        {isOpenChat ? <FaqBody /> : null}
      </ChatBodyWrap>

      <button className={classNamesButton} onClick={handleToggleChat}>
        <ChevronDownIcon className={classNamesButtonIconChevron} />
        <ChatIcon className={classNamesButtonIconChat} />
      </button>
    </div>
  );
};

export default Chatbot;
